module.exports = __webpack_public_path__ + "resources/img/img_tibero_m_en.585107c1acf708287efc8f8c9f650755.png";